import projection from '../generated/pwj5n4f1.json';
import { AcceptanceManifest } from '../types';
export const pwj5n4f1AcceptanceManifest = projection as AcceptanceManifest;
